/* eslint-disable react/prop-types */
import * as React from 'react';

export const ArrowRight = props => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.7951 4.20438C12.3558 3.76529 11.6436 3.76512 11.2043 4.20438C10.7653 4.64366 10.7653 5.35592 11.2043 5.7952L17.4094 11.9988L11.2043 18.2039C10.7651 18.6431 10.7655 19.3553 11.2043 19.7947C11.6436 20.2341 12.3558 20.2341 12.7951 19.7947L19.7956 12.7957C20.2349 12.3564 20.2347 11.6442 19.7956 11.2049L12.7951 4.20438Z"
      fill={props.color || '#64748B'}
    />
    <path
      d="M5.00049 10.875C4.37917 10.875 3.87549 11.3787 3.87549 12C3.87549 12.6213 4.37917 13.125 5.00049 13.125H19C19.6213 13.125 20.125 12.6213 20.125 12C20.125 11.3787 19.6213 10.875 19 10.875H5.00049Z"
      fill={props.color || '#64748B'}
    />
  </svg>
);
